import { Controller } from '@hotwired/stimulus'
import { addClass, removeClass } from 'utils/toggle_class'

export default class extends Controller {
  static targets = ["cardsContainer", "gridButton", "listButton"]

  initialize() {
    this.buttons = [this.gridButtonTarget, this.listButtonTarget]
    this.buttons.forEach(element => {
      element.addEventListener("click", (e) => { this.onButtonClick(e) })
    })
  }

  onButtonClick(e) {
    e.preventDefault()

    this.buttons.forEach(element => {
      element.classList.remove("-selected")
    })

    e.currentTarget.classList.add("-selected")

    if (e.currentTarget === this.listButtonTarget) {
      this.cardsContainerTarget.classList.add("-list")
    } else {
      this.cardsContainerTarget.classList.remove("-list")
    }
  }
}
